/**
 * Whose house an order is for, at the top of the paperwork.
 *
 * Lysa, 2026-09-12: "if we can be sure the MO and WO both reflect the
 * homeowners name/address on the PDF file."
 *
 * Neither printed order said. A work order named the crew and the trades, a
 * material order named the supplier and the delivery date, and a stack of
 * printed orders on a desk was a stack of pages you had to open and read a line
 * item from to tell apart. The two documents go to different people for
 * different reasons, so they do not share a layout — but they share this, and
 * sharing it here is what stops one of them growing the fields back and the
 * other not.
 */

import { jobAddress } from "./search.js";
import type { Job } from "./types.js";

/**
 * Label/value pairs, in the order they are read. Empty values are dropped by
 * whatever draws them, so a job still loading — null — costs three blank rows
 * rather than a page that will not print.
 */
export function paperworkHeader(
  job: Job | null | undefined,
): readonly (readonly [string, string | null])[] {
  const where = job ? jobAddress(job) : "";
  return [
    ["Homeowner", job?.contact?.full_name ?? null],
    ["Address", where || null],
    ["Job", job?.job_number ? `#${job.job_number}` : null],
  ];
}
